(ns com.theplantscape.plant-web.api.diagrams
  (:require [com.theplantscape.plant-web.draw.api :as api]
            [com.theplantscape.plant-web.draw.constants :refer [api-url-build]]
            [com.theplantscape.plant-web.draw.state :refer [site-state]]))

(defn create-user-diagram
  [diagram]
  (api/make-request-async
   {:method :post
    :uri (api-url-build "/api/v2/diagrams/create")
    :params diagram
    :headers {:authorization (-> @site-state :auth :access_token)}}))

(defn delete-user-diagram
  [diagram cb]
  (api/make-request
   {:method :delete
    :uri (api-url-build "/api/v2/diagrams/delete/" diagram)
    :headers {:authorization (-> @site-state :auth :access_token)}}
   cb))

(defn delete-user-diagram-async
  [diagram]
  (api/make-request-async
   {:method :delete
    :uri (api-url-build "/api/v2/diagrams/delete/" diagram)
    :headers {:authorization (-> @site-state :auth :access_token)}}))

(defn fetch-user-diagram-async
  [diagram]
  (api/make-request-async
   {:method :get
    :uri (api-url-build "/api/v2/diagrams/fetch/" diagram)
    :headers {:authorization (-> @site-state :auth :access_token)}}))

(defn fetch-user-diagram
  [diagram cb]
  (api/make-request
   {:method :get
    :uri (api-url-build "/api/v2/diagrams/fetch/" diagram)
    :headers {:authorization (-> @site-state :auth :access_token)}}
   cb))

(defn save-user-diagram
  [diagram cb]
  (api/make-request
   {:method :get
    :uri (api-url-build "/api/v2/diagrams/update/" diagram)
    :headers {:authorization (-> @site-state :auth :access_token)}}
   cb))

(defn fetch-user-diagram-list
  [query-params]
  (api/make-request-async
   {:method :get
    :uri (api-url-build "/api/v2/diagrams/list")
    :headers {:authorization (-> @site-state :auth :access_token)}
    :params query-params}))

(defn store-users-diagram [values cb]
  (if (:xt/id values) 
    (api/make-request
     {:method :post
      :uri (api-url-build "/api/v2/diagrams/update/" (:xt/id values))
      :headers {:authorization (-> @site-state :auth :access_token)}
      :params (merge {:diagram|db (:db values)}
                     (:settings values))} cb)
    (prn "Unable to save missing document id.")))
